export default $el => {
  if ($el.length === 0)
    throw Error(`No element found with selector: ${$el.selector}.`);

  $el.select();
};
